
define('text!libs/strand/gulp/templates/lib_version.html',[],function () { return '<script>\n(function(scope) {\n\n\tscope.VERSION = \'{{{version}}}\';\n\n}(window.Strand = {} || window.Strand));\n</script>\n';});

